import { strict } from 'assert';
import useLocale from '../useLocale';
import useLoader from './useLoader';
import locales from '../locales';

const values = JSON.parse(process.env.REACT_APP_LOCALES_DATE_FNS);

if (process.env.NODE_ENV === 'development') {
  strict.equal(
    values.length,
    locales.length,
    'Each locale has date-fns locale'
  );
}

export default function useDateFnsLocale() {
  const [locale] = useLocale();
  const localeIndex = locales.indexOf(locale);

  return useLoader(values[localeIndex]).default;
}
